import React from "react";

import { Login } from "@components";
import { Layout } from "./PageLayouts";

function LoginPage() {
  return (
    <Layout
      variant="centered"
      align="center"
      showNav={false}
      showFooter={false}
    >
      <Login />
    </Layout>
  );
}

export { LoginPage };
